<div class="case-list borderline">
    <div class="case-list__top d-flex justify-content-start mb-6">
        <button
            mat-flat-button
            class="cta-button"
            (click)="openVaultDialog()"
            type="button"
            role="button"
            [attr.aria-label]="getDictionaryItem('addCase')"
            [attr.data-testid]="createCaseTestId"
            [disabled]="!isLoggedIn"
        >
            <span> {{ getDictionaryItem("addCase").toLocaleUpperCase() }} + </span>
        </button>
        <h1 class="h2 mt-1 ml-4">{{ getDictionaryItem("myCases") }}</h1>
    </div>

    @if (filterableItems && filterableItems.length > 0 && isLoggedIn) {
        <app-filter
            (filterChanged)="onFilterChanged($event)"
            [itemList]="filterableItems"
            [reportedByIds]="reportedByIds"
            [caseStatuses]="getActiveStatuses"
            [type]="type"
        ></app-filter>
    }

    @if (showMessageCenter) {
        <app-message-center [data]="messageCenter" [state]="messageCenterState" [progressCount]="5000" [isFixed]="true"></app-message-center>
    }

    @if (isLoading && isLoggedIn) {
        <div>
            <h2 class="text-center h4 sr-only" id="fetch-headline">Henter mine supportsager</h2>
            <div>
                <app-skeleton-loader
                    role="alert"
                    aria-labelledby="fetch-headline"
                    aria-busy="true"
                    [cardAmount]="6"
                    [show]="{ date: false, title: true, description: false, tags: true }"
                    [cardType]="'case-card'"
                ></app-skeleton-loader>
            </div>
        </div>
    }
    @if (isLoggedIn) {
        <div class="borderline">
            <div>
                @if ((filteredCaseList?.length === 0 || noFoundCases) && isLoggedIn && !isLoading) {
                    <h2 class="h3">
                        {{ getDictionaryItem("noCasesFound") }}
                    </h2>
                }
            </div>
            @for (case of filteredCaseList; track case.incidentid; let index = $index; let isLast = $last) {
                <app-case-card [case]="case" [index]="index" [style]="case.isFiltered ? 'display: none;' : ''"></app-case-card>

                @if (!isLast) {
                    <mat-divider class="m-4" [style]="case.isFiltered ? 'display: none;' : ''"></mat-divider>
                }
            }
        </div>
    }
</div>
